import { videoAnalytics } from '#/config/constants';

const operationalUserIds = {
  TWO_UP: 'GUEST_AGEGROUP_2',
  FIVE_UP: 'GUEST_AGEGROUP_5',
  EIGHT_UP: 'GUEST_AGEGROUP_8',
};

export const createOperationalInstanceId = cryptoApi => {
  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }

  if (cryptoApi?.getRandomValues) {
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    const hex = Array.from(bytes, byte =>
      byte.toString(16).padStart(2, '0'),
    ).join('');

    return `web-${hex}`;
  }

  return `web-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`;
};

export const getOperationalUserId = ageGroup =>
  operationalUserIds[ageGroup] || 'GUEST_AGEGROUP_UNKNOWN';

export const isRequiredOperationalEvent = event =>
  event === videoAnalytics.events.VIDEO_HEARTBEAT;

export const canSendAnalyticsEvent = (event, analyticsConsent) =>
  analyticsConsent || isRequiredOperationalEvent(event);

export const getAnalyticsEventParams = (
  event,
  payload,
  defaultParams,
  analyticsConsent,
) => {
  if (!canSendAnalyticsEvent(event, analyticsConsent)) {
    return null;
  }

  if (analyticsConsent) {
    return {
      ...payload,
      ...defaultParams,
    };
  }

  // Required playback measurement remains cookieless. Its identifiers live
  // only for this page load and cannot identify a viewer across sessions.
  return {
    ...payload,
    device_type: defaultParams.device_type,
    instance_id: defaultParams.operational_instance_id,
    user_id: getOperationalUserId(payload.video_age_group),
    unique_key: defaultParams.operational_unique_key,
  };
};
